import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const SchoolTypeStore = create((set) => ({
    schoolTypes: null,
    schoolType: null,
    currentPage: 1,
    pageSize: 9,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.schoolType[attributeName] = newValue;
            return { schoolType: state.schoolType };
        });
    },

    resetSchoolType: () => {
        set((state) => {
            return { schoolType: {} };
        });
    },

    loadAll: (pageSize, currentPage, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'schoolType/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({
                    schoolTypes: data.results,
                    bears: state.bears + 2,
                }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'schoolType/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ schoolType: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'schoolType/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    update: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'schoolType/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'schoolType/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default SchoolTypeStore;
